// This file is automatically generated. Do not edit it directly.
import { Database } from "@/types/database.types";
import { createClient } from "@supabase/supabase-js";

// Use environment variables for Supabase credentials
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Add checks to ensure variables are defined and not empty
if (!SUPABASE_URL || SUPABASE_URL.trim() === "") {
  throw new Error("Missing or empty environment variable: VITE_SUPABASE_URL");
}
if (!SUPABASE_PUBLISHABLE_KEY || SUPABASE_PUBLISHABLE_KEY.trim() === "") {
  throw new Error(
    "Missing or empty environment variable: VITE_SUPABASE_ANON_KEY",
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);
